<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="pageTitle" />
          <!-- /Page Header -->
          <!-- v-if="Object.keys(assignedData).length > 0" -->

          <div class="row lead-filter">
            <div class="mb-5 col-md-10">
              <ul class="contact-nav nav d-flex">
                <li class="col-md-1 me-0">
                  <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#unassigned"
                    :class="{ active: activeTab === 'unassigned' }" @click="setActiveTab('unassigned')">Unassigned</a>
                </li>
                <li class="col-md-1 me-0">
                  <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#assigned"
                    :class="{ active: activeTab === 'assigned' }" @click="setActiveTab('assigned')">Assigned</a>
                </li>
                <li class="col-md-1 me-0">
                  <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#closed"
                    :class="{ active: activeTab === 'closed' }" @click="setActiveTab('closed')">Closed Leads</a>
                </li>
                <li class="col-md-8 me-0">

                </li>
              </ul>
            </div>

            <div class="col-md-2" v-if="activeTab === 'assigned'">
              <div class="export-list text-sm-end">
                <ul>
                  <li>
                    <div class="form-sorts dropdown">
                      <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                        <i class="ti ti-filter-share"></i>Filter
                      </a>
                      <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                        <div class="filter-set-view">
                          <div class="filter-set-head">
                            <h4><i class="ti ti-filter-share"></i>Filter</h4>
                          </div>
                          <div class="filter-content-list">
                            <!-- <label for="search-status" class="mb-2">Start Date</label>
                            <div class="form-wrap icon-form">
                              <date-picker text-input placeholder="" class="datetimepicker form-control"
                                v-model="filters.start_date" :editable="true" :clearable="true"
                                :input-format="dateFormat" />
                              <span class="form-icon"><i class="ti ti-calendar-check"></i></span>
                            </div> -->

                            <label for="search-status" class="mb-2">Assign Start Date - Assign End Date</label>
                            <date-time-picker v-model="filters.date" range multi-calendars :enable-time-picker="false"
                              format="yyyy-MM-dd" />

                          </div>
                          <!-- <div class="filter-content-list">
                            <label for="search-status" class="mb-2">End Date</label>
                            <div class="form-wrap icon-form">
                              <date-picker text-input placeholder="" class="datetimepicker form-control"
                                v-model="filters.end_date" :editable="true" :clearable="true"
                                :input-format="dateFormat" />
                              <span class="form-icon"><i class="ti ti-calendar-check"></i></span>
                            </div>
                          </div> -->
                          <div class="filter-content-list">
                            <label for="search-status" class="mb-2">Assign To</label>
                            <!-- <div class="form-wrap icon-form">
                              <span class="form-icon"><i class="ti ti-search"></i></span>
                              <select v-model="filters.assign_to" class="form-control">
                                <option v-for="user in userData" :key="user.id" :value="user.id">
                                  {{ user.first_name }} {{ user.last_name || '' }}
                                </option>
                              </select>
                            </div> -->

                            <div class="form-wrap icon-form">
                              <span class="form-icon"><i class="ti ti-search"></i></span>
                              <vue-select :options="userData" v-model="filters.assign_to" placeholder="Select....."
                                :key="userData.id" :id="userData.id" @select="myChangeEvent($event,'assign_to')" autocomplete="off"
                                autocorrect="off" autocapitalize="off" spellcheck="false" />
                            </div>

                          </div>

                          <div class="filter-content-list">
                            <label for="search-status" class="mb-2">Asssign By</label>
                            <!-- <div class="form-wrap icon-form">
                              <span class="form-icon"><i class="ti ti-search"></i></span>
                              <select v-model="filters.assign_by" class="form-control">
                                <option v-for="user in userData" :key="user.id" :value="user.id">
                                  {{ user.first_name }} {{ user.last_name || '' }}
                                </option>
                              </select>
                            </div> -->

                            <div class="form-wrap icon-form">
                              <span class="form-icon"><i class="ti ti-search"></i></span>
                              <vue-select :options="userData" v-model="filters.assign_by" placeholder="Select....."
                                :key="userData.id" :id="userData.id" @select="myChangeEvent($event,'assign_by')" autocomplete="off"
                                autocorrect="off" autocapitalize="off" spellcheck="false" />
                            </div>

                          </div>
                        </div>
                        <div class="filter-reset-btns">
                          <div class="row">
                            <div class="col-6">
                              <a href="javascript:void(0);" class="btn btn-light" @click="resetFilters">Reset</a>
                            </div>
                            <div class="col-6">
                              <a href="javascript:void(0);" class="btn btn-primary" @click="applyFilters">Filter</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <Form :key="assignFormKey" ref="assignFormRef" @submit="handleSubmit" :validation-schema="schema" v-if="activeTab === 'unassigned'">
            <div class="row align-items-center py-3 mb-3 bg-white mx-0 leads-row-wrap">
              <div class="col"></div>
              <div class="col-md-10">
                <div v-for="(row, index) in rows" :key="index" class="row position-relative">
                  <div class="col-md-3 mb-2 mb-md-0">
                    <label class="col-form-label">Start</label>
                    <Field :name="'rows[' + index + '].start'" as="input" type="number" class="form-control"
                      v-model="row.start" />
                    <ErrorMessage :name="'rows[' + index + '].start'" class="text-danger" />
                  </div>
                  <div class="col-md-3 mb-2 mb-md-0">
                    <label class="col-form-label">End</label>
                    <Field :name="'rows[' + index + '].end'" as="input" type="number" class="form-control"
                      v-model="row.end" />
                    <ErrorMessage :name="'rows[' + index + '].end'" class="text-danger" />
                  </div>
                  <div class="col-md-3 mb-2 mb-md-0">
                    <div class="form-wrap mb-2 mb-md-0">
                      <label class="col-form-label">Territory</label>
                      <Field as="select" :name="'rows[' + index + '].territory_id'" class="form-select"
                        v-model="row.territory_id" @change="handleTerritoryChange(index)">
                        <option value="">-----Select-----</option>
                        <option v-for="ter in Territories" :key="ter.id" :value="ter.id">{{ ter.name }}</option>
                      </Field>
                      <ErrorMessage :name="'rows[' + index + '].territory_id'" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-3 ">
                    <div class="form-wrap">
                      <label class="col-form-label">Responsible</label>
                      <Field as="select" :name="'rows[' + index + '].responsible'" class="form-select"
                        v-model="row.responsible">
                        <option value="">-----None-----</option>
                        <option v-for="res in row.responsibles" :key="res.id" :value="res.id">{{ res.name }}</option>
                      </Field>
                      <ErrorMessage :name="'rows[' + index + '].responsible'" class="text-danger" />
                    </div>
                  </div>

                  <!-- Conditional Delete Button for all rows except the first -->
                  <div class="mt-2 position-absolute delete_row" v-if="index > 0">
                    <a href="#" @click="deleteRow(index)"><i class="ion-close-round text-danger"
                        data-bs-toggle="tooltip" title="Delete Row"></i></a>
                    <!-- <button type="button" class="btn btn-danger" @click="deleteRow(index)">Delete Row</button> -->
                  </div>
                </div>

                <!-- Button to Add New Row -->
                <div class="row align-items-center">
                  <div class="col-md-8">
                  </div>
                  <div class="col-md-4 text-end">
                    <button @click="addNewRow" type="button" class="btn btn-primary py-2 me-2">Add Row</button>
                    <button type="submit" class="btn btn-teal">Assign</button>
                  </div>
                </div>
              </div>
              <div class="col"></div>
            </div>
          </Form>
          <div class="card main-card">
            <div class="card-body">

              <!-- Leads List -->
              <div class="tab-pane" v-if="activeTab === 'unassigned'" id="unassigned">
                <div class="table-responsive custom-table">
                  <leads-table ref="childRef" :isAssigned="false" :manual-leads="isManualLeadsRoute"></leads-table>
                </div>
              </div>
              <div class="tab-pane" v-if="activeTab === 'assigned'" id="assigned">
                <div class="table-responsive custom-table">
                  <leads-table ref="childRef" :isAssigned="true" :filters="appliedFilters" :manual-leads="isManualLeadsRoute"></leads-table>
                </div>
              </div>
              <div class="tab-pane" v-if="activeTab === 'closed'" id="closed">
                <div class="table-responsive custom-table">
                  <leads-table ref="closedRef" :isClosed="true" :filters="closedFilters" :manual-leads="isManualLeadsRoute"></leads-table>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Leads List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
  computed,
  nextTick
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRoute,
  useRouter
} from "vue-router";
import {
  Form,
  ErrorMessage,
  Field
} from "vee-validate";
import * as Yup from "yup";

export default {
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      dateFormat: "yyyy/MM/dd",
    };
  },
  computed: {
    isManualLeadsRoute() {
      return Boolean(this.$route.meta.manualLeads);
    },
    pageTitle() {
      return this.isManualLeadsRoute ? "Manual Leads" : "Leads";
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const assignFormRef = ref(null);
    const assignFormKey = ref(0);
    const childRef = ref(null);
    const closedRef = ref(null);
    const closedFilters = ref({});
    const file_id = ref(route.query.fileId || localStorage.getItem('fileId') || null);
    // Reactive state
    const rows = ref([{
      territory_id: '',
      responsible: '',
      start: '',
      end: '',
      responsibles: []
    }]);

    const filters = ref({
      date: null,
      assign_to: '',
      assign_by: ''
    });

    const appliedFilters = ref({});

    const activeTab = ref("unassigned");

    const Territories = computed(() => store.getters['organisation/getTerritories']);
    // Validation schema using yup
    // const schema = Yup.object().shape({
    //   rows: Yup.array().of(
    //     Yup.object().shape({
    //       start: Yup.string().required('Start is required'),
    //       end: Yup.string().required('End is required'),
    //       territory_id: Yup.string().required('Territory is required'),
    //       responsible: Yup.string().required('Responsible is required'),
    //     })
    //   ),
    // });

    const schema = Yup.object().shape({
      rows: Yup.array().of(
        Yup.object().shape({
          start: Yup.string()
            .required('Start is required'),
          end: Yup.string()
            .required('End is required')
            .test('is-greater', 'End must be greater than Start', function (value) {
              const { start } = this.parent;
              if (!start || !value) return true; // skip validation if empty
              return Number(start) <= Number(value);
            }),
          territory_id: Yup.string().required('Territory is required'),
          responsible: Yup.string().required('Responsible is required'),
        })
      ),
    });

    const assignedData = ref({});
    const userData = ref([])

    const fetchUsers = async () => {
      try {
        const params = {
          allUsers: 1
        }
        const response = await store.dispatch('users/fetchUsers', params);
        if (response.status) {
          // userData.value = response.data.data;
          // const staticOption = {
          //   id: '', // Ensure a unique ID for the static option
          //   initials: 'No',
          //   first_name: 'Select...',
          //   last_name: '',
          // };
          // userData.value.unshift(staticOption);

          userData.value = [
            { id: 'null', text: 'Select....', original: null },
            ...response?.data?.data?.map(item => ({
              id: item.id,
              text: item.first_name + ' ' + (item.last_name === null ? ' ' : item.last_name)
            }))
          ];

        } else {
          console.error("Failed to fetch users:", response);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    // Fetch territories on mount
    onMounted(async () => {
      store.dispatch('organisation/fetchTerritories')
      await fetchUsers();
    });

    const myChangeEvent = (event, field) => {
      if (event.id === 'null') {
        if(field === 'assign_to') {
          filters.value.assign_to = '';
        } else {
          filters.value.assign_by = '';
        }
      }
    }

    // Handle the territory change
    const handleTerritoryChange = async (index) => {
      const selectedTerritoryId = rows.value[index].territory_id;
      if (selectedTerritoryId) {
        try {
          // Fetch the responsible users for the selected territory
          const response = await store.dispatch('organisation/fetchTerritoryCompanyUsers', [selectedTerritoryId]);
          // Only update the responsibles for the current row
          rows.value[index].responsibles = response || [];
          rows.value[index].responsible = ''; // Reset responsible selection
        } catch (error) {
          console.error("Error fetching responsibles:", error);
        }
      }
    };

    // Method to add a new row
    const addNewRow = () => {
      rows.value.push({
        territory_id: '',
        responsible: '',
        start: '',
        end: '',
        responsibles: []
      });
    };

    const handleSubmit = async () => {
      const assignData = rows.value.map((row) => ({
        from: row.start,
        to: row.end,
        territory_id: row.territory_id,
        assign_to: row.responsible,
      }));
      const assignPayload = { assign_data: assignData };
      if (route.meta?.manualLeads) {
        assignPayload.manual_leads = 1;
      }
      const data = await store.dispatch('leads/assignLeads', assignPayload);

      // Reset form after successful assign
      if (data?.data) {
        rows.value = [{
          territory_id: '',
          responsible: '',
          start: '',
          end: '',
          responsibles: []
        }];
        // Force remount vee-validate form to clear all validation state
        assignFormKey.value += 1;
      }

      if (childRef.value) {
        childRef.value.fetchLeadsData();
      }
    };

    const filterLead = (page=1) => {
      if (childRef.value) {
        childRef.value.fetchLeadsData(page);
      }
    };

    // Method to delete a row (except the first row)
    const deleteRow = (index) => {
      rows.value.splice(index, 1); // Removes the row at the given index
    };

    const applyFilters = () => {
      appliedFilters.value = { ...filters.value };
      // Wait for the filters to be applied, then fetch reports
      nextTick(() => {
        filterLead();
      });
    };

    const resetFilters = () => {
      filters.value = {
        date: null,
        assign_to: '',
        assign_by: ''
      };
      applyFilters();
    };

    const setActiveTab = (tab) => {
      activeTab.value = tab

      nextTick(() => {
        if (tab === 'closed' && closedRef.value) {
          closedRef.value.fetchLeadsData();
        } else if (childRef.value) {
          childRef.value.fetchLeadsData();
        }
      })
    }

    watch(
      () => route.meta?.manualLeads,
      () => {
        // Same component instance is reused between Leads and Manual leads routes,
        // so we need to refetch when the route flag changes.
        nextTick(() => {
          if (activeTab.value === 'closed' && closedRef.value) {
            closedRef.value.fetchLeadsData(1);
          } else if (childRef.value) {
            childRef.value.fetchLeadsData(1);
          }
        });
      }
    );

    onMounted(() => {
      if (childRef.value) {
        childRef.value.fetchLeadsData();
      }
    })

    return {
      childRef,
      closedRef,
      assignFormRef,
      assignFormKey,
      closedFilters,
      handleSubmit,
      schema,
      handleTerritoryChange,
      file_id,
      Territories,
      rows,
      addNewRow,
      deleteRow,
      assignedData,
      activeTab,
      filters,
      appliedFilters,
      filterLead,
      applyFilters,
      resetFilters,
      fetchUsers,
      userData,
      setActiveTab,
      myChangeEvent
    }
  }
};
</script>

<style lang="scss" scoped>
.delete_row {
  right: -30px;
  top: 25px;
  width: 25px;
  height: 25px;
  border: 1px solid red;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    margin-left: 1px;
  }
}

.lead-filter {
  margin: 24px 0px;
  padding-top: 20px;
  // margin-bottom: 24px;
  background-color: #FFF;
  border-radius: 5px;
  border: 0;
  box-shadow: none;
}
</style>
